import { Button } from "@/components/ui/button";
import { Link } from "wouter";
import { useEffect, useState, useRef } from "react";
import { Check } from "lucide-react";

export default function HowItWorks({ content }) {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.15 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="bg-musicBlack py-24 section-transition relative overflow-hidden"
    >
      <div className="editorial-container relative z-10">
        {/* heading */}
        <div
          className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-1000 ${
            isVisible ? "opacity-100" : "opacity-0"
          }`}
        >
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-4 text-white">
            {content.title}
          </h2>
          <p className="font-sans text-lg text-white/80">{content.subtitle}</p>
        </div>

        {/* cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {
            /*[
            {
              step: "1",
              title: "Register Your Work",
              text: "Creators/rights holders register musical works and establish ownership.",
              link: "/creators",
              delay: "100ms",
            },
            {
              step: "2",
              title: "License for Business",
              text: "Businesses obtain proper licenses through our streamlined process to legally use music in commercial settings.",
              link: "/businesses",
              delay: "300ms",
            },
            {
              step: "3",
              title: "Track & Collect",
              text: "Music Nation tracks usage, collects and distributes royalties, and provides transparent reporting for creators/rights holders.",
              link: "/creators",
              delay: "500ms",
            },
          ]*/ content.cards.map(({  title, description }, i) => (
              <div
                key={i}
                className={`bg-musicBlack border border-musicGrey/20 p-8 rounded-lg transition-all duration-700 transform ${
                  isVisible
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 translate-y-10"
                } hover-lift spotlight shadow-lg`}
                style={{ transitionDelay: (i*150) + 'ms' }}
              >
                <div className="h-12 w-12 flex items-center justify-center bg-gradient-to-br from-musicRed to-musicRedDark rounded-full mb-6 shadow-lg shadow-musicRed/20">
                  <span className="font-serif text-xl font-bold text-musicWhite">
                    {i + 1}
                  </span>
                </div>
                <h3 className="font-serif text-xl font-bold mb-3 text-white">
                  {title}
                </h3>
                <p className="text-white/80 mb-4 font-sans">{description}</p>
                {/*<Link
                to={link}
                className="text-musicRed hover:text-musicRed/80 inline-flex items-center font-medium group font-sans"
              >
                Learn more
                <Check className="ml-2 w-4 h-4 transform transition-transform duration-500 group-hover:translate-x-1" />
              </Link>*/}
              </div>
            ))
          }
        </div>
      </div>

      {/* angled divider */}
      <div className="absolute bottom-0 left-0 right-0 overflow-hidden z-10">
        <svg
          className="w-full"
          style={{ height: "60px", display: "block" }}
          viewBox="0 0 1200 60"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
          fill="#111111"
        >
          <polygon points="0,60 1200,60 1200,0 600,60 0,0" />
        </svg>
      </div>
    </section>
  );
}
